__webpack_require__.p = "https://t-shopify-polish.alpha.groovehq.com/app-release/";